import React, { useRef } from 'react'

import { Icon, palette } from '@centivo/react-components'
import classNames from 'classnames'
import { useLocation } from 'react-router'
import { NavLink } from 'react-router-dom'
import styled, { css } from 'styled-components'

import { useOnClickOutside, useToggle } from '_hooks'

const ButtonWrapper = styled.button`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
  border-bottom: 2px solid transparent;

  &.active,
  &:hover {
    color: ${palette.brand.teal};
    border-bottom-color: ${palette.brand.teal};
  }
`

const List = styled.ul`
  display: block;
  list-style: none;
  position: absolute;
  border: 1px solid ${palette.neutral['grey-bbbdbf']};
  right: -1rem;
  padding: 0;
  z-index: 10;
  background-color: ${palette.neutral.white};

  & > li a {
    font-weight: 600;
  }
`

const activeItemStyles = css`
  background-color: ${palette.brand.teal};
  color: ${palette.neutral.white};
`

const Item = styled.li<{ isActive?: boolean }>`
  & a {
    display: block;
    color: ${palette.neutral['grey-95989a']};
    padding: 0.25rem 0.5rem;
    white-space: nowrap;
    line-height: 1.875rem;

    &:hover,
    &.active {
      ${activeItemStyles}
    }
  }
`

const TabLabel = styled.p`
  position: absolute;
  font-size: 0.875rem;
  font-weight: 700;
  white-space: nowrap;
  right: 0;
  margin-top: 0.25rem;
  color: ${palette.brand.teal};
`

export const MoreNavitem: React.FC = () => {
  const location = useLocation()
  const [open, toggleOpen, setOpen] = useToggle(false)

  const menu = useRef<HTMLUListElement>(null)
  const button = useRef<HTMLButtonElement>(null)
  useOnClickOutside(
    () => {
      setOpen(false)
    },
    [menu, button],
    []
  )

  const activeTab = {
    'practice-profile': 'Practice Profile',
    'practice-reports': 'Practice Reports',
    plan: 'Plan Resources',
  }
  const tabKey = Object.keys(activeTab).find(active =>
    location.pathname.includes(active)
  ) as keyof typeof activeTab | undefined

  const onSelectLink = () => setOpen(false)

  const label = open ? 'Show menu with remaining navigation tabs' : 'Close menu'

  return (
    <>
      <ButtonWrapper
        className={classNames({
          active: Boolean(tabKey),
        })}
        ref={button}
        type="button"
        onClick={toggleOpen}
        aria-expanded={open}
        aria-label={label}
      >
        More <Icon size="1.25rem" icon="chevron-down" />
      </ButtonWrapper>
      {tabKey && <TabLabel>{activeTab[tabKey]}</TabLabel>}
      {open && (
        <List>
          <Item>
            <NavLink to="/practice-profile" onClick={onSelectLink}>
              Practice Profile
            </NavLink>
          </Item>
          <Item>
            <NavLink to="/practice-reports" onClick={onSelectLink}>
              Practice Reports
            </NavLink>
          </Item>
          <Item>
            <NavLink to="/plan" onClick={onSelectLink}>
              Plan Resources
            </NavLink>
          </Item>
        </List>
      )}
    </>
  )
}
